// import { useEffect } from 'react'
// import useHeaderOps from '../../../hooks/useHeaderOps'
// import React from 'react'

// export default function ActivitySC(props) {

//     // to do header operations
//     const headerOps = useHeaderOps(props)
//     useEffect(()=>{
//         // when page loads, set the sub-heading
//     headerOps.setUserContentSubHeader("STEMBOT Coding")
//     },[])

//     // loads the provided html file in IFrame
//     return (<>
//         <section id="frame_dynamic_content" style={{ "background-color": "#2f3f89" }}>
//             <iframe
//                 src={process.env.PUBLIC_URL + "/scratch3/index.html"}
//                 id="wrkspc_frame"
//                 // className='workspace-scratch'
//                 style={{height: "94vh",minHeight:'auto'}}
//             />
//         </section>
//     </>)
// }



// import React, { useEffect, useState } from 'react';

// const ActivitySC = ({ headerOps }) => {
//     const [xmlContent, setXmlContent] = useState(null);

//     // Fetch XML data from the assets folder
//     useEffect(() => {
//         console.log("iframe:", document.getElementById('wrkspc_frame')); // Check if iframe is present

//         if (headerOps && headerOps.setUserContentSubHeader) {
//             headerOps.setUserContentSubHeader("STEMBOT Coding");
//         } else {
//             console.error("headerOps is not properly defined or imported.");
//         }

//         // Fetch XML content for SC activity
//         fetch('/assets/Tutorials/SC/VoiceControlRobot.xml')
//             .then(response => response.text())
//             .then(data => {
//                 setXmlContent(data);
//                 sendXmlToIframe(data);
//             })
//             .catch(error => console.error('Error loading XML file:', error));
//     }, [headerOps]);

//     // Send XML to the iframe once it is loaded
//     const sendXmlToIframe = (xml) => {
//         const iframe = document.getElementById('wrkspc_frame');
//         console.log("Sending XML to iframe:", xml); // Log XML being sent

//         if (iframe && iframe.contentWindow) {
//             iframe.contentWindow.postMessage({
//                 type: 'LOAD_WORKSPACE',
//                 xml: xml
//             }, '*');
//         } else {
//             console.error("Iframe not found or not ready.");
//         }
//     };

//     return (
//         <div>
//             <iframe
//                 src={process.env.PUBLIC_URL + "/scratch3/index.html"}
//                 id="wrkspc_frame"
//                 style={{ height: "94vh", width: "100%" }}
//                 title="Scratch Workspace"
//             />
//         </div>
//     );
// };

// export default ActivitySC;



// import React, { useEffect } from "react";

// const ActivitySC = (props) => {

//   useEffect(() => {
//     const iframe = document.getElementById("wrkspc_frame");

//     iframe.onload = () => {
//       const fileName = props.selectedTutorial.file_name;

//       iframe.contentWindow.postMessage({
//         type: "LOAD_SB3",
//         url: `/assets/Tutorials/SC/${fileName}.sb3`
//       }, "*");
//     };
//   }, [props.selectedTutorial]);

//   return (
//     <iframe
//       id="wrkspc_frame"
//       src="/scratch3/index.html"
//       style={{ height: "94vh", width: "100%" }}
//       title="Scratch Workspace"
//     />
//   );
// };

// export default ActivitySC;


// import React, { useEffect } from "react";

// const ActivitySC = (props) => {

//   useEffect(() => {

//     const iframe = document.getElementById("wrkspc_frame");

//     const sendProject = () => {

//       if (!props.selectedTutorial?.file_name) return;

//       const fileName = props.selectedTutorial.file_name;

//       console.log("📤 Sending SB3 request:", fileName);

//       iframe.contentWindow.postMessage({
//         type: "LOAD_SB3",
//         fileName: fileName
//       }, "*");
//     };

//     iframe.onload = () => {
//       // wait a little for Scratch to fully boot
//       setTimeout(sendProject, 1500);
//     };

//   }, [props.selectedTutorial]);

//   return (
//     <iframe
//       id="wrkspc_frame"
//       src="/scratch3/index.html"
//       style={{ height: "94vh", width: "100%" }}
//       title="Scratch Workspace"
//     />
//   );
// };

// export default ActivitySC;



// import React, { useEffect } from "react";

// const ActivitySC = (props) => {

//   useEffect(() => {

//     const iframe = document.getElementById("wrkspc_frame");

//     if (!iframe) return;

//     iframe.onload = () => {

//       // ✅ If no tutorial selected → do NOTHING (blank canvas)
//       if (!props.selectedTutorial?.file_name) {
//         console.log("🟢 Opening blank Scratch workspace");
//         return;
//       }

//       const fileName = props.selectedTutorial.file_name;

//       console.log("📤 Sending SB3 request:", fileName);

//       setTimeout(() => {
//         iframe.contentWindow.postMessage({
//           type: "LOAD_SB3",
//           fileName: fileName
//         }, "*");
//       }, 1500);
//     };

//   }, [props.selectedTutorial]);

//   return (
//     <iframe
//       key={props.selectedTutorial?.file_name || "blank"} 
//       id="wrkspc_frame"
//       src="/scratch3/index.html"
//       style={{ height: "94vh", width: "100%" }}
//       title="Scratch Workspace"
//     />
//   );
// };

// export default ActivitySC;




import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

const ActivitySC = (props) => {

  const location = useLocation();

  useEffect(() => {

    const iframe = document.getElementById("wrkspc_frame");
    if (!iframe) return;

    iframe.onload = () => {

      // ✅ If opened from main Scratch card
      if (location.pathname === "/activity/scratch-coding") {
        console.log("🟢 Blank Scratch Workspace Opened");
        return;
      }

      // ✅ If tutorial selected
      if (!props.selectedTutorial?.file_name) return;

      const fileName = props.selectedTutorial.file_name;

      console.log("📤 Sending SB3 request:", fileName);

      setTimeout(() => {
        iframe.contentWindow.postMessage({
          type: "LOAD_SB3",
          fileName: fileName
        }, "*");
      }, 1500);
    };

  }, [props.selectedTutorial, location.pathname]);

  return (
    <iframe
      key={location.pathname + (props.selectedTutorial?.file_name || "")}
      id="wrkspc_frame"
      src="/scratch3/index.html"
      style={{ height: "94vh", width: "100%" }}
      title="Scratch Workspace"
    />
  );
};

export default ActivitySC;